import React from 'react';
import api from '../services/api';

// Accounts queue — sales invoices with a short GRC and no credit note yet (§6).
// Raising the note nets the invoice (net_receivable) so payment_status can close.
const inr = (v) => '₹' + Number(v || 0).toLocaleString('en-IN');

export default function CreditNoteQueue() {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [busy, setBusy] = React.useState('');
  const [err, setErr] = React.useState('');

  const load = React.useCallback(() => {
    setLoading(true);
    api.get('/finance/credit-notes/pending').then(r => setRows(r.data.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);
  React.useEffect(() => { load(); }, [load]);

  const raise = async (row) => {
    const reason = window.prompt(`Raise credit note ${inr(row.credit_value)} for invoice ${row.invoice_no}\n(${row.short_qty} pcs short: invoiced ${row.invoiced_qty}, GRC'd ${row.grc_qty}).\nReason (optional):`, '');
    if (reason === null) return;   // cancelled
    setBusy(row.sales_invoice_id); setErr('');
    try {
      await api.post('/finance/credit-notes', { sales_invoice_id: row.sales_invoice_id, reason });
      load();
    } catch (e) { setErr(e.response?.data?.error || 'Failed to raise credit note'); } finally { setBusy(''); }
  };

  const th = { padding: '9px 10px', textAlign: 'left', color: '#555', fontWeight: 600, borderBottom: '2px solid #eee', fontSize: 11, whiteSpace: 'nowrap' };
  const td = { padding: '9px 10px', fontSize: 13, borderBottom: '1px solid #f5f5f5' };

  return (
    <div style={{ background: '#fff', borderRadius: 10, padding: 18 }}>
      <div style={{ fontSize: 13, color: '#666', marginBottom: 12 }}>
        Short GRC — credit note pending. Raising a note nets the invoice so it can close; RSR absorbs the credit value. One note per invoice.
      </div>
      {err && <div style={{ background: '#FDECEC', color: '#A32D2D', padding: '8px 10px', borderRadius: 6, fontSize: 12, marginBottom: 12 }}>{err}</div>}
      {loading ? <div style={{ color: '#aaa', padding: 24 }}>Loading…</div> : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr>{['Buyer / Brand', 'Invoice', 'GPO', 'DC', 'GRC date', 'Invoiced', "GRC'd", 'Short', 'Credit', 'Age', ''].map((h, i) => <th key={i} style={th}>{h}</th>)}</tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={11} style={{ ...td, textAlign: 'center', color: '#aaa' }}>No short-GRC invoices awaiting a credit note. 🎉</td></tr>}
            {rows.map(r => (
              <tr key={r.sales_invoice_id}>
                <td style={td}>{r.buyer_name || '—'}{r.brand_name ? ' / ' + r.brand_name : ''}</td>
                <td style={{ ...td, fontFamily: 'monospace' }}>{r.invoice_no}{r.busy_invoice_no ? <span style={{ color: '#999' }}> · {r.busy_invoice_no}</span> : ''}</td>
                <td style={{ ...td, fontFamily: 'monospace' }}>{r.gpo_no || '—'}</td>
                <td style={td}>{r.dc_name || '—'}</td>
                <td style={td}>{r.grc_date ? String(r.grc_date).slice(0, 10) : '—'}</td>
                <td style={td}>{Number(r.invoiced_qty).toLocaleString('en-IN')}</td>
                <td style={td}>{Number(r.grc_qty).toLocaleString('en-IN')}</td>
                <td style={{ ...td, color: '#A32D2D', fontWeight: 600 }}>{Number(r.short_qty).toLocaleString('en-IN')}</td>
                <td style={{ ...td, fontWeight: 600 }}>{inr(r.credit_value)}</td>
                <td style={{ ...td, color: Number(r.days_since_grc) > 7 ? '#A32D2D' : '#888' }}>{r.days_since_grc}d</td>
                <td style={td}>
                  <button disabled={busy === r.sales_invoice_id} onClick={() => raise(r)}
                    style={{ padding: '5px 12px', background: '#3B3A8F', color: '#fff', border: 'none', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                    {busy === r.sales_invoice_id ? 'Raising…' : 'Raise credit note'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
